import { render, staticRenderFns } from "./AppointmentsItem.vue?vue&type=template&id=bc60c492&"
import script from "./AppointmentsItem.vue?vue&type=script&lang=ts&"
export * from "./AppointmentsItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports